import { useCurrentLocation } from './useCurrentLocation';

export type OneIdEnvironment = { revenuePrefix: '/revenue' | '/revpro' };

export const useOneIdEnvironment = (): OneIdEnvironment => {
  const { host } = useCurrentLocation();

  return {
    revenuePrefix: host.startsWith('one') ? '/revenue' : '/revpro',
  };
};
